import Button from "@/Components/Button/Button";
import Modal, { ModalProps } from "@/Components/Modal/Modal";
import { QwertyKeyboard } from "@/Components/NumbersKeyPad/Keyboard";
import { useModalMeta, useSetModal } from "@/shared/atoms/useModal";
import { useUpdateCartItemByIndex } from "@/shared/hooks/useCartHook";
import useCommon from "@/shared/hooks/useCommon";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const KioskCartItemNoteModal = ({ ...props }: ModalProps) => {
  const t = useCommon();
  const { t: tPos } = useTranslation("", { keyPrefix: "posOrders" });
  const [{ index, cartItem, id }] = useModalMeta();
  const [note, setNote] = useState(cartItem?.note || "");
  const updateProductByIndex = useUpdateCartItemByIndex();
  const setModal = useSetModal();

  const reopenKioskCheckout = () => {
    setModal("kioskCheckout", { id });
  };

  const handleDone = () => {
    updateProductByIndex(index, { ...cartItem, note });
    reopenKioskCheckout();
  };

  return (
    <Modal width="95%" {...props} onExit={reopenKioskCheckout}>
      <div className="text-center text-[5rem] font-black">
        {tPos("addNote")}
      </div>
      <div className="mt-4 text-center text-[2.75rem] font-light">
        {tPos("enterYourComment")}
      </div>

      <div className="my-16 flex w-full flex-col items-center gap-8">
        <input
          readOnly
          placeholder={tPos("remark")}
          value={note}
          className="w-full rounded-4xl border-none bg-grey p-[2rem_4rem] text-center text-[3rem] font-black"
        />
        <div className="w-[75%]">
          <QwertyKeyboard
            withSpace
            value={note}
            setValue={setNote}
            onChange={setNote}
            onEnter={handleDone}
          />
        </div>
      </div>

      <div className="flex gap-4">
        <div className="w-full">
          <Button onClick={reopenKioskCheckout} variant="secondary" size="large">
            {t("goBack")}
          </Button>
        </div>
        <div className="w-full">
          <Button onClick={handleDone} size="large">
            {tPos("save")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default KioskCartItemNoteModal;
